const HUBSPOT_PORTAL_ID = '6889326';

const _hsq = (window._hsq = window._hsq || []);

const realUserEmail = window.current_real_user_email;
const realUserId = window.current_real_user_id;

if (realUserEmail && realUserId) {
    _hsq.push([
        'identify',
        {
            email: realUserEmail,
            id: (window.site ? window.site + '-' : '') + realUserId,
        },
    ]);
}

_hsq.push(['trackPageView']);

const loader = document.createElement('script');
loader.id = 'hs-script-loader';
loader.async = true;
loader.defer = true;
loader.src = `//js.hs-scripts.com/${HUBSPOT_PORTAL_ID}.js`;
document.head.appendChild(loader);
